/* eslint-disable react/jsx-props-no-spreading */
import { AppliedFilters, ProductGrid, ProductList } from 'components/product';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectFilter } from 'selectors/selector';

const Shop = () => {
  useDocumentTitle('Menu | Amutham');
  useScrollTop();

  const store = useSelector(
    (state) => ({
      filteredProducts: selectFilter(state.products.items, state.filter),
      products: state.products,
      requestStatus: state.app.requestStatus,
      isLoading: state.app.loading
    }),
    shallowEqual
  );

  const hour = new Date().getHours();
  let keyword = '';
  if (hour >= 5 && hour < 11) keyword = 'Breakfast';
  else if (hour >= 11 && hour < 17) keyword = 'Lunch';
  else if (hour >= 17 && hour < 23) keyword = 'Dinner';
  else if (hour === 23 || hour < 5) keyword = '';

  return (
    <main className="content">
      <section className="product-list-wrapper">
        <AppliedFilters filteredProductsCount={store.filteredProducts.length} />
        <h2
          style={{
            textAlign: 'center',
            paddingTop: '7px',
            background: 'gainsboro'
          }}
        >
          {keyword}
        </h2>
        <ProductList {...store}>
          <ProductGrid products={store.filteredProducts} />
        </ProductList>
      </section>
    </main>
  );
};

export default Shop;
